import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=9482c9e6&scoped=true&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=9482c9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482c9e6",
  null
  
)

export default component.exports